import React, { useState } from 'react';
import { toast } from 'sonner';
import { FileDown, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { downloadFile, fetchPdfFile } from '../lib/pdfReports';

/**
 * Downloads a server-generated PDF report.
 * - path: API path, e.g. '/progress/summary/pdf'
 * - params: query params (period, offset)
 * - filename: name for the saved file
 */
const ExportPdfButton = ({ api, path, params, filename, testId = 'export-pdf-btn' }) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      downloadFile(await fetchPdfFile(api, path, params, filename));
      toast.success('PDF report downloaded');
    } catch {
      toast.error('Failed to generate PDF report');
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleExport}
      disabled={exporting}
      data-testid={testId}
    >
      {exporting ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <FileDown className="h-4 w-4 mr-2" />}
      EXPORT PDF
    </Button>
  );
};

export default ExportPdfButton;
